module.exports = __webpack_public_path__ + "static/img/icon.3ab19eb2.svg";